import React from 'react'
import dayjs from 'dayjs'
import {
	ComputerDesktopIcon,
	GlobeAltIcon,
	XMarkIcon,
	ClockIcon,
} from '@heroicons/react/24/outline'

const DeviceCard = ({
	device,
	isCurrent,
	isDarkMode,
	onRemove,
	isRemoving,
}) => {
	const lastCheckIn = dayjs(device.lastCheckIn).fromNow()
	const isExtension = device.deviceType === 'extension'

	// Format company name: maz_express_llc -> MAZ EXPRESS LLC
	const formatCompanyName = companyName => {
		if (!companyName || companyName === 'Unknown') return null
		return companyName.replace(/_/g, ' ').toUpperCase()
	}

	return (
		<div
			className={`${isDarkMode ? 'bg-gray-700' : 'bg-white'} border ${
				isDarkMode ? 'border-gray-600' : 'border-gray-200'
			} rounded-lg px-4 py-4`}
		>
			<div className="flex items-center justify-between">
				<div className="space-y-1">
					<div className="flex items-center gap-2">
						<GlobeAltIcon className="h-5 w-5" />
						<span
							className={`font-medium text-${
								isDarkMode ? 'white' : 'gray-900'
							}`}
						>
							{isExtension && formatCompanyName(device.companyName)
								? formatCompanyName(device.companyName)
								: device.browser}
						</span>
						{isExtension && (
							<span
								className={`px-1.5 py-0.5 text-xs rounded-full ${
									isDarkMode
										? 'bg-blue-500/20 text-blue-400'
										: 'bg-blue-100 text-blue-700'
								}`}
							>
								Extension
							</span>
						)}
						{device.loginMethod && (
							<span
								className={`px-1.5 py-0.5 text-xs rounded-full ${
									device.loginMethod === 'google'
										? isDarkMode
											? 'bg-orange-500/20 text-orange-400'
											: 'bg-orange-100 text-orange-700'
										: isDarkMode
											? 'bg-gray-500/20 text-gray-400'
											: 'bg-gray-100 text-gray-600'
								}`}
							>
								{device.loginMethod === 'google' ? 'Google Sign-In' : 'Email / Password'}
							</span>
						)}
						<span
							className={`px-2 py-0.5 ${
								isCurrent ? 'text-sm font-medium' : 'text-xs'
							} rounded-full ${
								isCurrent
									? 'bg-green-500/15 text-green-500'
									: `${
											isDarkMode
												? 'bg-gray-600 text-gray-300'
												: 'bg-gray-200 text-gray-700'
									  }`
							} flex items-center gap-1`}
						>
							{isCurrent ? (
								'Current'
							) : (
								<>
									<ClockIcon className="h-3 w-3" />
									{lastCheckIn}
								</>
							)}
						</span>
					</div>
					<div
						className={`flex items-center gap-2 text-sm text-${
							isDarkMode ? 'gray-300' : 'gray-600'
						}`}
					>
						<ComputerDesktopIcon className="h-4 w-4" />
						<span>
							{device.os}
							{(device.city || device.country) && ' • '}
							{device.city && device.country ? `${device.city}, ${device.country}` : (device.city || device.country)}
							{isExtension && device.extensionVersion && (
								<span className={`text-${isDarkMode ? 'gray-400' : 'gray-500'}`}>
									{' '}• Extension v{device.extensionVersion} • {device.browser}
								</span>
							)}
						</span>
					</div>
				</div>
				{!isCurrent && (
					<button
						onClick={onRemove}
						disabled={isRemoving}
						className={`px-2 py-1 rounded text-xs ${
							isDarkMode
								? 'bg-red-200/10 text-red-300 hover:bg-red-500/20'
								: 'bg-red-50 text-red-600 hover:bg-red-100'
						} transition-colors`}
					>
						{isRemoving ? (
							<div className="h-3 w-3 animate-spin rounded-full border-2 border-current border-t-transparent" />
						) : (
							<span className="flex items-center gap-1">
								<XMarkIcon className="h-3 w-3" />
								Remove
							</span>
						)}
						<span className="sr-only">Remove device</span>
					</button>
				)}
			</div>
		</div>
	)
}

export default DeviceCard
